export type StorageConsent = 'accepted' | 'rejected';

const CONSENT_KEY = 'gamez.storageConsent';

export function getStorageConsent(): StorageConsent | null {
  try {
    const value = localStorage.getItem(CONSENT_KEY);
    return value === 'accepted' || value === 'rejected' ? value : null;
  } catch {
    return null;
  }
}

export function isStorageConsentAccepted(): boolean {
  return getStorageConsent() === 'accepted';
}

export function setStorageConsent(consent: StorageConsent): void {
  try {
    localStorage.setItem(CONSENT_KEY, consent);
  } catch {
    // Se lo storage non è disponibile, la scelta vale solo per la sessione corrente.
  }
}

export function clearStoredPreferences(): void {
  try {
    for (const key of Object.keys(localStorage)) {
      if (key.startsWith('gamez.') && key !== CONSENT_KEY) {
        localStorage.removeItem(key);
      }
    }
  } catch {
    // noop
  }
}

export async function clearBrowserCaches(): Promise<void> {
  if ('caches' in window) {
    const names = await caches.keys();
    await Promise.all(names.map((name) => caches.delete(name)));
  }

  if ('serviceWorker' in navigator) {
    const registrations = await navigator.serviceWorker.getRegistrations();
    await Promise.all(registrations.map((registration) => registration.unregister()));
  }
}